import React, { useEffect } from "react";
import PdfPageFrame from "../../components/PdfPageFrame";

function PolitiqueDeConfidentialiteScreen() {
  useEffect(() => {
    document.body.style.overflowX = 'hidden';
    return () => { document.body.style.overflowX = ''; };
  }, []);



  return (
    <>
      <div style={{ background: 'var(--vert-clair-nuance-5)', minHeight: '100vh' }}>
      <section className="section-3" style={{background: "none", paddingBottom: "64px", paddingTop: "2em"}}>
          <div className="page containerAccueil">
            <PdfPageFrame>
              <div id="pdfContent" style={{
                  position: 'relative', 
                  textAlign: 'justify', 
                  textJustify: "inter-word", 
                  width: 'auto',
                  fontSize: "14px", 
                  lineHeight: "1.5714285714285714",
                  fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'",
                  listStyle: "none",
                  padding: "20mm 20mm"
                }}
              >
                <h1>Politique de Confidentialité</h1>

                <h2>1. Introduction</h2>
                <p>
                    La société <strong>RAVAIL SAS</strong> (ci-après « RAVAIL »), dont le siège social est situé au 19B rue du Gaudron, 95270 Viarmes, France, s’engage à protéger la confidentialité de vos données personnelles. Cette Politique de Confidentialité décrit la manière dont nous collectons, utilisons et partageons vos données personnelles.
                </p>
                <p>
                    RAVAIL met régulièrement à jour cette Politique pour refléter les évolutions de ses pratiques ou des exigences légales. La date de la dernière mise à jour est mentionnée en bas de page.
                </p>

                <h2>2. Responsable de traitement</h2>
                <div>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Raison sociale :</strong> RAVAIL SAS</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Siège social :</strong> 19B rue du Gaudron, 95270 Viarmes, France</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Email :</strong> contact@ravail.fr</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Téléphone :</strong> +33 1 84 80 80 41</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Délégué à la protection des données :</strong> dpo@ravail.fr</span>
                </div>

                <h2>3. Données collectées</h2>
                <p>
                    En tant que responsable du traitement, RAVAIL collecte uniquement les données nécessaires à la sécurité et à la fourniture de ses services. Ces données incluent principalement :
                </p>
                <div>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Nom et prénom(s)</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Fonction au sein du service (ex : médecin, infirmier, secétaire, etc.)</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Adresse email professionnelle</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Numéro de téléphone professionnel</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Nom du service employeur</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Adresse IP</span>
                </div>
                <p>
                  En tant que sous-traitant, RAVAIL traite également des données de santé à caractère personnel pour le compte de ses clients (Service de Prévention et de Santé au Travail). Ces données sont collectées et traitées conformément aux instructions de nos clients et dans le respect des normes réglementaire, de sécurité et de confidentialité française.
                </p>

                <h2>4. Finalités du traitement</h2>
                <p>
                    Vos données personnelles sont collectées pour les finalités suivantes :
                </p>
                <div>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Fournir nos services</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Vous contacter en réponse à une demande</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Assurer le suivi des relations clients</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Respecter nos obligations légales et réglementaires</span>
                </div>

                <h2>5. Partage des données</h2>
                <p>
                    Vos données peuvent être transmises à des prestataires tiers pour assurer la maintenance et l’hébergement (OVH SAS) de nos services. Ces prestataires sont tenus de respecter des normes strictes en matière de sécurité et de confidentialité (ex: certification Hébergeur de données de santé, chiffrement des données, accès restreint, etc.).
                </p>
                <p>
                    Nous ne vendons en aucun cas vos données personnelles. Elles peuvent être partagées dans les cas suivants :
                </p>
                <div>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Si la loi française l’exige (ex : ordonnance judiciaire)</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Avec votre consentement (ex : transfert de dossier suite à un changement de service de santé au travail)</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>De manière anonymisée et groupée dans le cadre d'études de santé publique</span>
                </div>

                <h2>6. Sécurité des données</h2>
                <p>
                    RAVAIL met en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre toute perte, accès non autorisé ou divulgation.
                </p>

                <h2>7. Hébergement des données</h2>
                <p>
                    Vos données sont stockées en France sur les serveurs d’<strong>OVH SAS</strong>, certifié Hébergeur de Données de Santé (HDS) et conforme à la norme ISO 27001.
                </p>
                <div>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Raison sociale :</strong> OVH SAS</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Adresse :</strong> 2 rue Kellermann - 59100 Roubaix - France</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Site web :</strong> <a href="https://www.ovhcloud.com" target="_blank" rel="noreferrer">www.ovhcloud.com</a></span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Certification HDS :</strong> OVH est certifié Hébergeur de Données de Santé (HDS). <a href="https://www.lne.fr/recherche-certificats/data_certificats/37387-5.pdf" target="_blank" rel="noreferrer">Voir le certificat</a></span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span><strong>Certification ISO 27001 : </strong> OVH est certifié ISO 27001. <a href="https://www.lne.fr/recherche-certificats/data_certificats/37383-6.pdf" target="_blank" rel="noreferrer">Voir le certificat</a></span>
                </div>

                <h2>8. Vos droits</h2>
                <p>
                    Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants concernant vos données personnelles :
                </p>
                <div>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Droit d’accès</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Droit de rectification</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Droit à l’effacement</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Droit à la limitation du traitement</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Droit d’opposition</span>
                    <span className="puce-item"><span style={{marginRight: "0.3em"}}>•</span>Droit à la portabilité des données</span>
                </div>
                <p>
                    Pour exercer vos droits, contactez-nous par email à l’adresse suivante : <a href="mailto:rgpd@ravail.fr">rgpd@ravail.fr</a>
                </p>

                <h2>9. Conservation des données</h2>
                <p>
                    Les données des comptes des professionnels de santé sont conservées pendant toute la durée de la relation contractuelle et jusqu’à 1 an après la fin de celle-ci.
                </p>
                <p>
                    Les données de santé collectées pour le compte de nos clients (SPST) sont conservées conformément à leurs instructions ainsi qu'aux obligations légales et réglementaires en vigueur.
                </p>

                <h2>10. Cookies</h2>
                <p>
                    Le site utilise uniquement des cookies nécessaires au bon fonctionnement du service, notamment pour la gestion des sessions d'authentification.
                </p>
                <p>
                  Aucun cookie tiers n'est utilisé pour collecter des informations sur l'utilisateur ni pour suivre sa navigation.
                </p>

                <h2>11. Droit applicable</h2>
                <p>
                    La présente Politique de Confidentialité est régie par le droit français. En cas de litige, les tribunaux compétents seront ceux de Paris.
                </p>

                <footer>
                    <p><em>Dernière mise à jour : 28/10/2025</em></p>
                </footer>
              </div>
            </PdfPageFrame>
          </div>
      </section>
      </div>
    </>
  );
}

export default PolitiqueDeConfidentialiteScreen;
